(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/xperten.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/xperten.js');

'use strict';

svs.maltipset.views.Xperten = Marionette.View.extend({
  useBaseRow: false,
  template: function(data) {
    return svs.maltipset.templates.xperten(data);
  },
  className: 'padding-1 padding-bottom-0',
  modelEvents: {
    change: 'render'
  },
  events: {
    'click .js-btn-xperten': 'onXpertenClick',
    'click .js-btn-xperten-base-row': 'onBaseRowSelect',
    'click .js-help-dialog-board-row': 'helpDialogBoardRow'
  },
  initialize: function() {
    this.originalUseBaseRow = this.useBaseRow = this.model.get('xpertBaseRowMode');

    this.model.set('minNoOfRows', 1);
    this.model.set('maxNoOfRows', svs.maltipset.constants.NUMBER_OF_ROWS_NOSYSTEM);

    if (
      (this.model.get('xpertSystem') !==
          svs.maltipset.constants.XPERT_PROPERTIES.NOXPERT &&
          this.model.get('xpertSystem') !==
            svs.maltipset.constants.XPERT_PROPERTIES.MODIFIEDQP) ||
        this.model.get('xpertBaseRowMode')
    ) {
      this.changeDoneButtonState(false);
      this.systemSize = this.model.get('xpertSize');
      this.originalSystemSize = this.model.get('xpertSize');
    }
  },
  changeDoneButtonState: function(disabled) {
    $('.modal-button-right').prop('disabled', disabled);
  },
  onXpertenClick: function(event) {
    this.changeDoneButtonState(false);
    this.systemSize = parseInt(
      event.currentTarget.attributes['data-system'].value,
      10
    );
    this.changed =
        this.changed || this.systemSize !== this.originalSystemSize;
    this.model.set('xpertSize', this.systemSize);
  },
  onBaseRowSelect: function() {
    var oldValue = this.useBaseRow;
    this.useBaseRow = !this.useBaseRow;
    this.changed =
        this.changed || this.useBaseRow !== oldValue;
    this.model.set('xpertBaseRowMode', this.useBaseRow);
  },

  helpDialogBoardRow: function(e) {
    if (svs.maltipset.data.config.helpTexts) {
      var _dialog = new svs.components.dialog.Contextual({
        branding: svs.components.dialog.branding.SPORT,
        attachTo: $(e.currentTarget),
        zIndex: 1400,
        title: svs.maltipset.data.config.helpTexts.xperten_board_row.title,
        message: [
          {
            type: svs.components.dialog.message.TEXT,
            text: svs.maltipset.data.config.helpTexts.xperten_board_row.body
          }
        ]
      });
      svs.components.dialog.api.add(_dialog);
    }
  }
});


 })(window);